import React, {Component} from 'react';
import {Map} from '../Map'

import './location.css';

class Location extends Component {

  render() {
    let title = this.props.data.title;
    let address = this.props.data.address;
    let coords = this.props.data.coords;
    return (
      <div className="location-wrapper">
        <div className="location-info">
          <div className="location-title">
            {title}
          </div>
          <br></br>
          <div className="location-address">
            {address.line1}
            <br></br>
            {address.line2}
            <br></br>
            {address.line3}
          </div>
        </div>
        <div className="location-map-container">
          <Map lat={coords.lat} lng={coords.lng}></Map>
        </div>
      </div>
    );
  }
}

export default {Location}



// WEBPACK FOOTER //
// ./src/components/Location/index.js